import React, { useEffect } from 'react';
import { Route, Routes, useNavigate, redirect } from 'react-router-dom';

import { useAuth } from 'contexts/auth';

// Pages
import Login from 'pages/Login';
import Sucesso from 'pages/Sucesso/Sucesso';
import DividaDetalhe from 'pages/DividaDetalhe';
import EnviarAcordo from 'pages/EnviarAcordo';
import ResumoBoleto from 'pages/ResumoBoleto';
import LoginLayout from 'layouts/LoginLayout';
import LoggedLayout from 'layouts/LoggedLayout';

// Logged Pages
import Dashboard from 'pages/Dashboard/Dashboard';

interface RedirectProps {
  to: string
}
function Redirect({ to }: RedirectProps) {
  const navigate = useNavigate()
  useEffect(
    () => {
      navigate(to)
    }, []
  )
  return (<></>)
}

export default function Router() {
  const { loading = true } = useAuth();

  if (loading) return null;

  return (
    <Routes>

      <Route path='/' element={<LoginLayout />}>
        <Route path='sucesso' element={<Sucesso />} />
        <Route path='login/:trackId?' element={<Login />} />
        <Route path='/' element={<Redirect to='/login' />} />
      </Route>

      <Route path='/dashboard/' element={<LoggedLayout />}>
        <Route index element={<Dashboard />} />
        <Route path='detalhes-divida' element={<DividaDetalhe />} />
        <Route path='enviar-acordo' element={<EnviarAcordo />} />
        <Route path='resumo-boleto' element={<ResumoBoleto />} />
      </Route>

    </Routes >
  );
}
